import ApiConnector from 'src/helpers/ApiConnector'
import User from 'src/models/User'

const ApiLocalStorage = {
  requestData (name, apiUrl, method, data, time) {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem(name) &&
        new Date().getTime() - new Date(JSON.parse(localStorage.getItem(name)).time).getTime() <= time) {
        resolve(JSON.parse(localStorage.getItem(name)).result)
      } else {
        let apiConnector = new ApiConnector()
        apiConnector.request(method, apiUrl, data).then((response) => {
          localStorage.setItem(name, JSON.stringify({'time': new Date().getTime(), 'result': response.data}))
          resolve(response.data)
        })
      }
    })
  },

  requestUserData (name, apiUri) {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem(name)) {
        let data = JSON.parse(localStorage.getItem(name))
        resolve(data)
      } else {
        let apiConnector = new ApiConnector()
        apiConnector.request('post', apiUri, '').then((response) => {
          localStorage.setItem(name, JSON.stringify({
            'lic': response.data.licenses[0].lic,
            'options': response.data.options,
            'licList': response.data.licenses
          }))
          resolve({'lic': response.data.licenses[0].lic, 'options': response.data.options})
        })
      }
    })
  },

  getUserLic () {
    return new User().getLic()
  },
  getUserOptions () {
    return new User().getOptions()
  },
  getDateRange () {
    if (localStorage.getItem('dateRange')) {
      return JSON.parse(localStorage.getItem('dateRange'))
    } else {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      return [start, end]
    }
  },
  setDateRange (date) {
    localStorage.setItem('dateRange', JSON.stringify(date))
  }

}

export default ApiLocalStorage



// WEBPACK FOOTER //
// ./src/helpers/ApiLocalStorage.js